import { create } from 'zustand';
import { Tag } from 'src/common/interfaces/tag.interface';

interface State {
  currentTags: any[];
  setCurrentTags: (tags: any[]) => void;
  updateTag: (tags: Tag) => void;
  createTag: (tag: Tag) => void;
  deleteTag: (tags: Tag) => void;
}

export const useCurrentTags = create<State>((set: any, get: any) => ({
  currentTags: [],
  setCurrentTags: (tags: any[]) => {
    const currentTags = get().currentTags;
    if (JSON.stringify(tags) !== JSON.stringify(currentTags)) {
      set({
        currentTags: tags || [],
      });
    }
  },
  updateTag: (tag: Tag) => {
    set((state: any) => {
      const tags = state.tags.map((w: Tag) => {
        return w.id === tag.id ? tag : w;
      });
      return {
        currentTags: tags,
      };
    });
  },
  createTag: (tag: Tag) => {
    set((state: any) => {
      return {
        currentTags: [...state.tags, tag],
      };
    });
  },
  deleteTag: (tag: Tag) => {
    set((state: any) => {
      return {
        currentTags: state.tags.filter((w: Tag) => w.id !== tag.id),
      };
    });
  },
}));
